module.exports = __webpack_public_path__ + "img/121.09222fa1.jpg";